exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-line-fullscreen[data-v-3633261d]{top:23px;right:45px}.label-title[data-v-3633261d]{font-size:20px;font-weight:700}", ""]);

// exports
